import type { FileUploadData } from '@stratumn/studio-shared';

export const initialFileUploadData: FileUploadData = {
  title: 'Default File Upload Title',
  required: true
};
